import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Tile template for table-grid in grid mode
 */
@Directive({
  selector: '[mbsGridTile]'
})
export class GridTileDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
